module.exports = __webpack_public_path__ + "img/ai-conversation.f116e693.webp";